<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Customer"
              bc1="App"
              bc2="Customer"
              bc3="Transactions"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$emit('backFromDetailPage')"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <section v-if="transactionDetails.length" class="invoice-preview-wrapper">
          <div class="row invoice-preview">
            <!-- Invoice -->
            <div class="col-12">
              <div class="card invoice-preview-card">
                <div class="card-body invoice-padding pb-0">
                  <!-- Header starts -->
                  <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                    <div>
                      <div class="logo-wrapper">
                        <h3><img width="150" :src="`${publicPath}vaults-authlogo.png`"></h3>
                      </div>


                    </div>

                  </div>
                  <!-- Header ends -->
                </div>

                <hr class="invoice-spacing"/>

                <div class="table-responsive">
                  <table class="table">
                    <thead>
                    <tr>
                      <th class="py-1"></th>
                      <th class="py-1">UUID</th>
                      <th class="py-1">Gateway Reference Id</th>
                      <th class="py-1">Sender Account Title</th>
                      <th class="py-1">Sender Account Number</th>
                      <th class="py-1">Receiver Account Title</th>
                      <th class="py-1">Receiver Account Number</th>
                      <th class="py-1">Status</th>
                      <th class="py-1">Amount</th>
                      <th class="py-1">Vat</th>
                      <th class="py-1">Fee</th>
                      <th class="py-1">Payable Amount</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(item,index) in transactionDetails">

                      <tr>
                        <td class="py-1">
                          <button type="button"
                                  class="btn btn-sm btn-icon font-weight-bolder font-medium-1 rounded-circle btn-warning waves-effect waves-float waves-light"
                                  data-toggle="collapse" :data-target="'#demo'+index" @click="accordionToShow  = index">
                            +
                          </button>
                        </td>
                        <td class="py-1" style="cursor: pointer"  @click="$router.push({name: 'transactions-detail',params: {id:item.uuid}})">{{ item.uuid }}</td>
                        <td class="py-1">{{ item.gateway_reference_id }}</td>
                        <td class="py-1">{{ item.sender_account_title }}</td>
                        <td class="py-1">{{ item.sender_account_number }}</td>
                        <td class="py-1">{{ item.receiver_account_title }}</td>
                        <td class="py-1">{{ item.receiver_account_number }}</td>
                        <template>
                          <td class="py-1" v-if="item.status == 1"><span class="badge  mt-1  badge-glow badge-success">Success</span></td>
                          <td class="py-1" v-else-if="item.status == 2"><span class="badge  mt-1  badge-glow badge-danger">Failed</span></td>
                          <td class="py-1" v-else><span class="badge  mt-1  badge-glow badge-warning">Pending</span></td>
                        </template>
                        <td class="py-1">{{ parseFloat(item.amount / 100).toFixed(3) }}</td>
                        <td class="py-1">{{ parseFloat(item.vat / 100).toFixed(3) }}</td>
                        <td class="py-1">{{ parseFloat(item.fee / 100).toFixed(3) }}</td>
                        <td class="py-1">{{ parseFloat((item.amount - item.fee - item.vat) / 100).toFixed(3) }}</td>
                      </tr>
                      <tr>
                        <td colspan="4" class="hiddenRow ">
                          <div class="collapse" :id="'demo'+index">
                            <div class="card-body">
                              <div class="card">
                                <table class="table border-dark  badge-glow">
                                  <thead>
                                  <tr>
                                    <th>UUID</th>
                                    <th>Reference Id</th>
                                    <th>Sender Account Title</th>
                                    <th>Receiver Account Title</th>
                                    <th>Amount</th>
                                    <th>Total Amount</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="(chargesTransactionsItem,chargesTransactionsItemIndex) in item.charges_transactions">
                                    <td>{{chargesTransactionsItem.uuid}}</td>
                                    <td>{{chargesTransactionsItem.reference_id}}</td>
                                    <td>{{chargesTransactionsItem.sender_account_title}}</td>
                                    <td>{{chargesTransactionsItem.receiver_account_title}}</td>
                                    <td>{{parseFloat(chargesTransactionsItem.amount/100).toFixed(3)}}</td>
                                    <td>{{parseFloat(chargesTransactionsItem.total_amount/100).toFixed(3)}}</td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                    </tbody>
                  </table>
                </div>


              </div>
            </div>


          </div>
        </section>


      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['rowData'],
  mounted() {
    this.customer = this.rowData
    this.getTransactionsDetails()
  },
  data() {
    return {
      customer: [],
      transactionDetails: [],
      accordionToShow: -1,

    }
  },
  methods: {
    getTransactionsDetails() {
      let data = {
        customerId: this.customer.id
      }
      this.makeRequest("post", "v1/get-customers-transactions", data, {}, false).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData)
                this.transactionDetails = responseData
              }
            }
          }
      );
    }
  },
  // watch:{
  //   rowData(val){
  //     console.log(val)
  //     this.transactionDetails = []
  //     this.customer = val
  //     this.getTransactionsDetails()
  //   }
  // }

}
</script>
<style>
.table-scroll-y {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}
</style>

